import React from "react"

type OriginDialogContextReturn = {
  openDialogFlow: boolean
  setOpenDialogFlow: (arg: boolean) => void
}

export const OriginDialogContext = React.createContext<OriginDialogContextReturn>(null)
